export const QCHEM_RADIO_BUTTONS = [
  {
    id: 'one-configuration',
    name: 'configuration',
    label: 'One configuration',
    value: 'bondlength',
  },
  {
    id: 'all-configurations',
    name: 'configuration',
    label: 'All configurations',
    value: 'full',
  },
]
